module.exports = __webpack_public_path__ + "img/restaurant-2.de832b75.jpg";